import React from 'react';
import { Flex } from 'antd';

import { Page } from '../../../../../shared/ui/Page';
import { PromocodesContainer } from '../containers/PromocodesContainer';
import { PromocodeCreateButton } from '../components/PromocodeCreateButton';

export const PromocodesPage = () => {
    return (
        <Page isBackButton title={'Настройки промокодов'}>
            <Flex vertical gap={24}>
                <PromocodeCreateButton />
                <PromocodesContainer />
            </Flex>
        </Page>
    );
};
